import { createContext } from "react";

const tagContext = createContext();

export default tagContext;
